// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 로딩바 오버레이 */
.loading-bar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(2px);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  animation: fadeInOverlay 0.3s ease-out forwards;
}

@keyframes fadeInOverlay {
  to {
    opacity: 1;
  }
}

/* 로딩바 컨테이너 */
.loading-bar-container {
  width: 80%;
  max-width: 600px;
  text-align: center;
}

/* 로딩바 트랙 */
.loading-bar-track {
  width: 100%;
  height: 6px;
  background-color: #f0f0f0;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

/* 로딩바 채움 */
.loading-bar-fill {
  height: 100%;
  background: linear-gradient(90deg, #e84118, #ff6348, #e84118);
  background-size: 200% 100%;
  border-radius: 10px;
  animation: progressBarAnimation 2s ease-in-out infinite, shimmer 1.5s ease-in-out infinite;
  box-shadow: 0 2px 10px rgba(232, 65, 24, 0.3);
}

/* 진행률 애니메이션 */
@keyframes progressBarAnimation {
  0% {
    width: 0%;
  }
  50% {
    width: 70%;
  }
  100% {
    width: 100%;
  }
}

/* 반짝임 효과 */
@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

/* 로딩 메시지 */
.loading-bar-message {
  font-size: 16px;
  color: #333;
  font-weight: 500;
  opacity: 0;
  animation: fadeInMessage 0.5s ease-out 0.3s forwards;
}

@keyframes fadeInMessage {
  to {
    opacity: 1;
  }
}

/* 펄스 애니메이션 추가 */
.loading-bar-message::after {
  content: '';
  display: inline-block;
  width: 4px;
  height: 4px;
  background-color: #e84118;
  border-radius: 50%;
  margin-left: 8px;
  animation: pulse 1s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.5;
    transform: scale(1.2);
  }
}

/* 작은 화면 대응 */
@media (max-width: 768px) {
  .loading-bar-container {
    width: 90%;
  }
  
  .loading-bar-message {
    font-size: 14px;
  }
  
  .loading-bar-track {
    height: 4px;
    margin-bottom: 15px;
  }
}

/* 다크 모드 버전 (선택적) */
@media (prefers-color-scheme: dark) {
  .loading-bar-overlay {
    background-color: rgba(0, 0, 0, 0.95);
  }
  
  .loading-bar-track {
    background-color: #333;
  }
  
  .loading-bar-message {
    color: #fff;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/css/LoadingBar.css"],"names":[],"mappings":"AAAA,aAAa;AACb;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,2CAA2C;EAC3C,0BAA0B;EAC1B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,+CAA+C;AACjD;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA,aAAa;AACb;EACE,UAAU;EACV,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,YAAY;EACZ,6DAA6D;EAC7D,0BAA0B;EAC1B,mBAAmB;EACnB,0FAA0F;EAC1F,6CAA6C;AAC/C;;AAEA,cAAc;AACd;EACE;IACE,SAAS;EACX;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;AACF;;AAEA,WAAW;AACX;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA,WAAW;AACX;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,oDAAoD;AACtD;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,qBAAqB;EACvB;AACF;;AAEA,aAAa;AACb;EACE;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;AACF;;AAEA,mBAAmB;AACnB;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/* 로딩바 오버레이 */\n.loading-bar-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(2px);\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  animation: fadeInOverlay 0.3s ease-out forwards;\n}\n\n@keyframes fadeInOverlay {\n  to {\n    opacity: 1;\n  }\n}\n\n/* 로딩바 컨테이너 */\n.loading-bar-container {\n  width: 80%;\n  max-width: 600px;\n  text-align: center;\n}\n\n/* 로딩바 트랙 */\n.loading-bar-track {\n  width: 100%;\n  height: 6px;\n  background-color: #f0f0f0;\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);\n  margin-bottom: 20px;\n}\n\n/* 로딩바 채움 */\n.loading-bar-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #e84118, #ff6348, #e84118);\n  background-size: 200% 100%;\n  border-radius: 10px;\n  animation: progressBarAnimation 2s ease-in-out infinite, shimmer 1.5s ease-in-out infinite;\n  box-shadow: 0 2px 10px rgba(232, 65, 24, 0.3);\n}\n\n/* 진행률 애니메이션 */\n@keyframes progressBarAnimation {\n  0% {\n    width: 0%;\n  }\n  50% {\n    width: 70%;\n  }\n  100% {\n    width: 100%;\n  }\n}\n\n/* 반짝임 효과 */\n@keyframes shimmer {\n  0% {\n    background-position: -200% 0;\n  }\n  100% {\n    background-position: 200% 0;\n  }\n}\n\n/* 로딩 메시지 */\n.loading-bar-message {\n  font-size: 16px;\n  color: #333;\n  font-weight: 500;\n  opacity: 0;\n  animation: fadeInMessage 0.5s ease-out 0.3s forwards;\n}\n\n@keyframes fadeInMessage {\n  to {\n    opacity: 1;\n  }\n}\n\n/* 펄스 애니메이션 추가 */\n.loading-bar-message::after {\n  content: '';\n  display: inline-block;\n  width: 4px;\n  height: 4px;\n  background-color: #e84118;\n  border-radius: 50%;\n  margin-left: 8px;\n  animation: pulse 1s ease-in-out infinite;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.5;\n    transform: scale(1.2);\n  }\n}\n\n/* 작은 화면 대응 */\n@media (max-width: 768px) {\n  .loading-bar-container {\n    width: 90%;\n  }\n  \n  .loading-bar-message {\n    font-size: 14px;\n  }\n  \n  .loading-bar-track {\n    height: 4px;\n    margin-bottom: 15px;\n  }\n}\n\n/* 다크 모드 버전 (선택적) */\n@media (prefers-color-scheme: dark) {\n  .loading-bar-overlay {\n    background-color: rgba(0, 0, 0, 0.95);\n  }\n  \n  .loading-bar-track {\n    background-color: #333;\n  }\n  \n  .loading-bar-message {\n    color: #fff;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
